import React from "react";

const SlideUpFadeIn = ({ 
	children, 
	delay = 0, 
	duration = 0.6, 
	distance = 40, 
	direction = "up", // "up", "down", "left", "right"
	style = {} 
}) => {
	const getTransform = (dir) => {
		switch (dir) {
			case "up":
				return `translateY(${distance}px)`;
			case "down":
				return `translateY(-${distance}px)`;
			case "left":
				return `translateX(${distance}px)`;
			case "right":
				return `translateX(-${distance}px)`;
			default:
				return `translateY(${distance}px)`;
		}
	};

	// Usar um ID único mas estável para evitar recriar a animação desnecessariamente
	const animationId = React.useRef(`slideIn-${Math.random().toString(36).substr(2, 9)}`).current;

	return (
		<>
			<style>
				{`
					@keyframes ${animationId} {
						from {
							opacity: 0;
							transform: ${getTransform(direction)};
						}
						to {
							opacity: 1;
							transform: none;
						}
					}
				`}
			</style>
			<div 
				style={{
					animation: `${animationId} ${duration}s ease-out ${delay}s both`,
					...style,
				}}
			>
				{children}
			</div>
		</>
	);
};

export default SlideUpFadeIn;

